import React from 'react'
import styled from 'styled-components'

export const DummyRow = () => {
  return (
    <HeaderRow style={ { visibility: 'hidden', height: 80, flex: '0 0 50', display: 'flex', flexDirection: 'row' } } />
  )
}

const HeaderRow = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 0px 1px 0px;
`



// WEBPACK FOOTER //
// ./src/components/calendar/vertical-table/dummy-row.js